import { setNectaryRegistry } from './utils';
setNectaryRegistry(window.customElements);
import './accordion-item/index.js';
import './accordion/index.js';
import './action-menu-option/index.js';
import './action-menu/index.js';
import './alert/index.js';
import './avatar/index.js';
import './badge/index.js';
import './button/index.js';
import './card-container/index.js';
import './card/index.js';
import './chat-block/index.js';
import './chat-bubble/index.js';
import './chat/index.js';
import './checkbox/index.js';
import './chip/index.js';
import './code-tag/index.js';
import './color-menu-option/index.js';
import './color-menu/index.js';
import './color-swatch/index.js';
import './date-picker/index.js';
import './dialog/index.js';
import './emoji-picker/index.js';
import './emoji/index.js';
import './field/index.js';
import './file-drop/index.js';
import './file-picker/index.js';
import './file-status/index.js';
import './flag/index.js';
import './grid-item/index.js';
import './grid/index.js';
import './help-tooltip/index.js';
import './horizontal-stepper-item/index.js';
import './horizontal-stepper/index.js';
import './icon-button/index.js';
import './icon/index.js';
import './inline-alert/index.js';
import './input/index.js';
import './link/index.js';
import './list-item/index.js';
import './list/index.js';
import './pagination/index.js';
import './pop/index.js';
import './popover/index.js';
import './progress-stepper-item/index.js';
import './progress-stepper/index.js';
import './progress/index.js';
import './radio-option/index.js';
import './radio/index.js';
import './rich-text/index.js';
import './rich-textarea/index.js';
import './segment-collapse/index.js';
import './segment/index.js';
import './segmented-control-option/index.js';
import './segmented-control/index.js';
import './segmented-icon-control-option/index.js';
import './segmented-icon-control/index.js';
import './select-button/index.js';
import './select-menu-option/index.js';
import './select-menu/index.js';
import './skeleton-item/index.js';
import './skeleton/index.js';
import './spinner/index.js';
import './stop-events/index.js';
import './table-body/index.js';
import './table-cell/index.js';
import './table-head-cell/index.js';
import './table-head/index.js';
import './table-row/index.js';
import './table/index.js';
import './tabs-icon-option/index.js';
import './tabs-option/index.js';
import './tabs/index.js';
import './tag/index.js';
import './text/index.js';
import './textarea/index.js';
import './tile-control-option/index.js';
import './tile-control/index.js';
import './time-picker/index.js';
import './title/index.js';
import './toast-manager/index.js';
import './toast/index.js';
import './toggle/index.js';
import './tooltip/index.js';
import './vertical-stepper-item/index.js';
import './vertical-stepper/index.js';